/** Offer amounts are per billing period; this formatter never scales prices. */
export function offerBillingLabel(months?: number | null): string {
  if (months == null) return '';
  if (months === 1) return 'month';
  if (months === 12) return 'year';
  return months % 12 === 0 ? `${months / 12} years` : `${months} months`;
}
